// extracted by mini-css-extract-plugin
export default {"wrap":"ContentModal_wrap__rOAWm","header":"ContentModal_header__R-6Zu","title":"ContentModal_title__KkUkS","btn":"ContentModal_btn__nIvwH"};